import { ThunkResult, Utilities } from "../../shared/utilities";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";
import { IAction } from "../model/IAction";
import { IElement } from "../model/IProcessData";
import { ParameterEditorValue } from "../model/ParameterEditorValue";
import { State } from "../model/State";
import { rebuildVariableScopesAndTriggerValidationAction, validationAction } from "./ValidateProcess";

export const UPDATE_PARAMETER = "UPDATE_PARAMETER";

/**
 * Creates action to update a parameter. The newValue can be either a ParameterEditorValue or a string (for trigger data)
 */
export function updateParameter(elementId: string | undefined, key: string | undefined, newValue: ParameterEditorValue | string | number | null): ThunkResult<void, State> {
  return (dispatch, getState) => {
    dispatch(triggerUpdateParameter(elementId, key, newValue));
    // Variable declarations live in these keys. The validation update will trigger for more than just variables, but w/e. It's better than triggering for everything.
    if (key === "variable" || key === "variableName" || key === "expression") {
      // Changing variable names should trigger the varaible scope to be rebuilt
      dispatch(rebuildVariableScopesAndTriggerValidationAction());
    } else {
      // For everything else we can leave the variable scopes as is
      dispatch(validationAction(getState()));
    }
  };
}

export function toggleWordWrap(elementId: string | undefined, key: string | undefined): ToggleWordWrapAction {
  return {
    type: TOGGLE_WORD_WRAP,
    elementId: elementId,
    key: key
  };
}
export const TOGGLE_WORD_WRAP = "TOGGLE_WORD_WRAP";
export interface ToggleWordWrapAction extends IAction {
  elementId: string | undefined;
  key: string | undefined;
}

export function triggerUpdateParameter(elementId: string | undefined, key: string | undefined, newValue: ParameterEditorValue | string | number | null): UpdateParameterAction {
  return {
    type: UPDATE_PARAMETER,
    elementId: elementId,
    key: key,
    newValue: newValue
  };
}

export interface UpdateParameterAction extends IAction {
  elementId: string | undefined;
  key: string | undefined;
  newValue: ParameterEditorValue | string | number | null;
}

export const SET_INITIAL_PARAMETER = "SET_INITIAL_PARAMETER";
export function setInitialParameters(elementId: string, newParameters: any): SetInitialParametersAction {
  return {
    type: SET_INITIAL_PARAMETER,
    elementId: elementId,
    newParameters: newParameters
  };
}
export interface SetInitialParametersAction extends IAction {
  elementId: string;
  newParameters: any;
}

export const CHANGE_FROM_ARRAY_TO_EXPRESSION = "CHANGE_FROM_ARRAY_TO_EXPRESSION";
export function changeFromArrayToExpressionType(elementId: string, key: string): ArrayTypeChangeAction {
  return {
    type: CHANGE_FROM_ARRAY_TO_EXPRESSION,
    elementId: elementId,
    key: key
  };
}

export interface ArrayTypeChangeAction extends IAction {
  elementId: string | undefined;
  key: string | undefined;
}

export const CHANGE_FROM_EXPRESSION_TO_ARRAY = "CHANGE_FROM_EXPRESSION_TO_ARRAY";
export function changeFromExpressionToArrayType(elementId: string | undefined, key: string | undefined): ArrayTypeChangeAction {
  return {
    type: CHANGE_FROM_EXPRESSION_TO_ARRAY,
    elementId: elementId,
    key: key
  };
}

export function initApiTrigger(elementId: string, selectedSpecId: number, selectedPathKey: string, selectedMethod: string): ThunkResult<void, State> {
  return async (dispatch, getState) => {
    const state = getState();
    const spec = state.apiSpecs.find((s) => s.id === selectedSpecId);
    if (!spec || !spec.activeVersion) {
      throw new Error(`No API spec found with ID '${selectedSpecId}'. The spec is probably from an orphaned process`);
    }
    const id = spec.activeVersion.id;

    const result = await Utilities.getFetch<IElement>(`api/apiSpec/start/${id}`, { selectedPath: selectedPathKey, selectedOperation: selectedMethod });

    // the element name is always set via BPMN, so the canvas and data are kept in sync
    BpmnJsCliWrapper.setLabel(elementId, result.name);

    return dispatch(setInitialParameters(elementId, result.parameters));
  };
}
